/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { policyModelSchema } from "../policyModelSchema.ts";
import { userPolicyTypeEnumSchema } from "../userPolicyTypeEnumSchema.ts";
import { z } from "zod";

export const getApiPolicyQueryParamsSchema = z.object({
    "LanguageCode": z.string().describe("Код языка"),
"Type": z.lazy(() => userPolicyTypeEnumSchema).describe("Тип политики. \n\r\n1 - Пользовательское соглашение \n\r\n2 - Политика обработки данных \n<p>Возможные значения:</p>\n<ul>\n<li><b>1 - TermsOfUse</b>: Пользовательское соглашение.</li>\n<li><b>2 - PrivacyPolicy</b>: Политика обработки данных.</li>\n<li><b>3 - DeleteAccountPolicy</b>: Политика удаления аккаунта</li>\n<li><b>4 - Offer</b>: Оферта</li>\n<li><b>5 - Regulation</b>: Устав</li>\n</ul>\n")
    })

/**
 * @description Политика
 */
export const getApiPolicy200Schema = z.lazy(() => policyModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiPolicy400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiPolicy401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiPolicy403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Политика не найдена
 */
export const getApiPolicy404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiPolicy500Schema = z.lazy(() => badResponseModelSchema)

export const getApiPolicyQueryResponseSchema = z.lazy(() => getApiPolicy200Schema)